import { createStyles, Theme } from '@material-ui/core';

export default (theme: Theme) => {
  const {
    spacing: { unit },
  } = theme;

  return createStyles({
    root: {
      display: 'flex',
      gap: `${unit}px`,
      '&$reverse': {
        justifyContent: 'flex-end',
      },
      alignItems: 'flex-end',
    },
    container: {
      display: 'flex',
      gap: `${unit}px`,
      alignItems: 'center',
      minHeight: 72,
      '&:hover $timeStamp': {
        opacity: 1,
      },
      '&$reverse': {
        flexDirection: 'row-reverse',
        flexGrow: 1,
      },
    },
    text: {
      maxWidth: '70%',
      backgroundColor: '#E9EFF0',
      padding: `${unit}px ${unit * 1.5}px`,
      borderRadius: '8px',
      wordBreak: 'break-word',
      hyphens: 'auto',
    },
    timeStamp: {
      whiteSpace: 'nowrap',
      opacity: 0,
      '-webkit-transition': 'all .3s ease',
      transition: 'all .3s ease',
      '-webkit-transition-delay': '.35s',
      transitionDelay: '.35s',
      alignSelf: 'end',
      marginBottom: unit * 2.5,
    },
    avatar: {
      marginBottom: unit / 2,
    },
    reverse: {},
  });
};
